import React from "react";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../css/qr.css";

const CrearQR = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  console.log(user);

  if (!user) {
    return <p>No estás logueado. Por favor, inicia sesión.</p>;
  }

  const handlePrint = () => {
    window.print();
  };

  const userUrl = `https://app.farmasite.com.ar/farmacia/${user.farmacia.cuit}`;

  return (
    <div
      className="crearqr-page"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div className="qr-container">
        <h2>Consulte aquí</h2>
        <h3>
          Lista de precios de
          <br />
          medicamentos
        </h3>
        <div className="qr-wrapper">
          <QRCode
            value={userUrl}
            size={256}
            bgColor="#FFFFFF"
            fgColor="#000000"
            level="H"
            includeMargin={true}
          />
        </div>
        <p>Escanea el QR para consultar los precios</p>
      </div>
      <div
        className="no-print"
        style={{
          marginTop: "2rem",
          display: "flex",
          justifyContent: "center",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <button className="btn-print"
          onClick={handlePrint}
        >
          Imprimir
        </button>

        <button className="btn-back"
          onClick={() => navigate(-1)}>
          Volver
        </button>
      </div>
    </div>
  );
};

export default CrearQR;
